import Box from "@mui/material/Box";
import MailIcon from "@mui/icons-material/Mail";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FavoriteIcon from "@mui/icons-material/Favorite";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { RED, RED_LIGHT, BORDER, MUTED } from "assets/theme/brandColors";

const cardSx = {
  bgcolor: "#fff",
  borderRadius: "14px",
  border: "1.5px solid",
  borderColor: BORDER,
  overflow: "hidden",
  mb: 2,
};

const cardLabelSx = {
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "1.2px",
  textTransform: "uppercase",
  color: MUTED,
  fontFamily: "Roboto, sans-serif",
};

const CONTACTS = [
  {
    icon: <MailIcon sx={{ fontSize: 18 }} />,
    label: "Email",
    value: "estiahelp@outlook.com",
    sub: "Bug reports, feedback, or anything on your mind",
    href: "mailto:estiahelp@outlook.com",
  },
  {
    icon: <InstagramIcon sx={{ fontSize: 18 }} />,
    label: "Instagram",
    value: "@estia.cooking",
    sub: "Follow along for updates and cooking inspiration",
    href: null,
    comingSoon: true,
  },
  {
    icon: <LinkedInIcon sx={{ fontSize: 18 }} />,
    label: "LinkedIn",
    value: "Estia Cooking",
    sub: "Connect with us professionally",
    href: "https://www.linkedin.com/company/estians",
  },
];

export default function SupportPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ pt: 3, pb: 6, px: { xs: 2, md: 3 }, display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", maxWidth: 560 }}>
          {/* Page header */}
          <Box sx={{ mb: 3.5 }}>
            <Box
              sx={{
                fontSize: 22,
                fontWeight: 800,
                color: "#222",
                mb: 0.75,
                fontFamily: "Roboto, sans-serif",
              }}
            >
              Contact
            </Box>
            <Box
              sx={{
                fontSize: 14,
                color: "#555",
                fontFamily: "Roboto, sans-serif",
                lineHeight: 1.6,
              }}
            >
              Questions, feedback, or just want to say hi — we&apos;d love to hear from you.
            </Box>
          </Box>

          {/* Contact */}
          <Box sx={cardSx}>
            <Box sx={{ px: 3, py: 2, borderBottom: "1px solid", borderColor: BORDER }}>
              <Box sx={cardLabelSx}>Contact & socials</Box>
              <Box sx={{ fontSize: 12, color: MUTED, mt: "4px", fontFamily: "Roboto, sans-serif" }}>
                We read everything — don&apos;t be shy
              </Box>
            </Box>
            {CONTACTS.map((c, i) => (
              <Box
                key={c.label}
                component={c.comingSoon ? "div" : "a"}
                href={c.comingSoon ? undefined : c.href}
                target={!c.comingSoon && c.href?.startsWith("http") ? "_blank" : undefined}
                rel={
                  !c.comingSoon && c.href?.startsWith("http") ? "noopener noreferrer" : undefined
                }
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  px: 3,
                  py: 2,
                  borderBottom: i < CONTACTS.length - 1 ? "1px solid #f5f5f5" : "none",
                  textDecoration: "none",
                  transition: "background 0.12s",
                  cursor: c.comingSoon ? "default" : "pointer",
                  ...(!c.comingSoon && { "&:hover": { bgcolor: "#fafafa" } }),
                  ...(!c.comingSoon && {
                    "&:hover .contact-arrow": { opacity: 1, transform: "translateX(3px)" },
                  }),
                }}
              >
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "10px",
                    bgcolor: c.comingSoon ? "#f0f0f0" : "#f0f0f0",
                    color: c.comingSoon ? "#bbb" : RED,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {c.icon}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      fontSize: 14,
                      fontWeight: 700,
                      color: c.comingSoon ? "#bbb" : "#222",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    {c.value}
                  </Box>
                  <Box
                    sx={{
                      fontSize: 12,
                      color: c.comingSoon ? "#ccc" : MUTED,
                      fontFamily: "Roboto, sans-serif",
                      mt: "2px",
                    }}
                  >
                    {c.sub}
                  </Box>
                </Box>
                {c.comingSoon ? (
                  <Box
                    sx={{
                      fontSize: 10,
                      fontWeight: 700,
                      letterSpacing: "0.8px",
                      textTransform: "uppercase",
                      color: "#bbb",
                      fontFamily: "Roboto, sans-serif",
                    }}
                  >
                    Coming soon
                  </Box>
                ) : (
                  <Box
                    className="contact-arrow"
                    sx={{
                      fontSize: 16,
                      color: MUTED,
                      opacity: 0,
                      transition: "opacity 0.15s, transform 0.15s",
                    }}
                  >
                    →
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          {/* Donate */}
          <Box
            sx={{
              bgcolor: "#1a1a1a",
              borderRadius: "14px",
              border: "1.5px solid",
              borderColor: "#2e2e2e",
              overflow: "hidden",
              p: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: RED,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FavoriteIcon sx={{ fontSize: 18 }} />
              </Box>
              <Box
                sx={{
                  fontSize: 15,
                  fontWeight: 800,
                  color: "#fff",
                  fontFamily: "Roboto, sans-serif",
                }}
              >
                Support Estia
              </Box>
            </Box>
            <Box
              sx={{
                fontSize: 13,
                color: "#fff",
                fontFamily: "Roboto, sans-serif",
                lineHeight: 1.7,
                mb: 2.5,
              }}
            >
              If you believe in the Estian movement and want to help keep this project alive,
              consider a small donation. Every contribution — big or small — makes a real
              difference.
            </Box>
            <Box
              component="button"
              onClick={() => window.open("https://www.paypal.com/donate", "_blank")}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                padding: "11px 24px",
                bgcolor: RED,
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                fontSize: 14,
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "Roboto, sans-serif",
                transition: "background 0.15s",
                "&:hover": { bgcolor: "#7d1520" },
              }}
            >
              <FavoriteIcon sx={{ fontSize: 15 }} />
              Donate via PayPal
            </Box>
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
}
